import React, { memo, useMemo } from "react";
import { Avatar } from "@chakra-ui/react";
import colors from "app/colors";
import { AvatarIcon, UserEmailCircleIcon } from "modules/icons";
import { getFullName } from "modules/utils/Functions";
import { UserRoleType } from "gql/graphql";

interface IProps {
  avatarUrl?: string | null;
  active: boolean;
  firstName: string;
  lastName: string;
  roleType: UserRoleType;
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "2xs" | "xs" | "full";
}

const InternalAdminUserAvatar = ({
  avatarUrl,
  active,
  firstName,
  lastName,
  roleType,
  size = "md",
}: IProps) => {
  const boxSize = useMemo(() => {
    switch (size) {
      case "sm":
        return 8;
      case "md":
        return 12;
      case "lg":
        return 16;
      case "xl":
        return 20;
      case "2xl":
        return 24;
      case "2xs":
        return 4;
      case "xs":
        //temporary bug fix for now; The real value for this sholud be 6 however there is some additional height somewhere causing the h-stack-with-overflow-tray component to improperly count overflow items
        return "22.3px";
      default:
        return 6;
    }
  }, [size]);

  if (roleType === "EMAIL") {
    return <UserEmailCircleIcon boxSize={boxSize} fill={colors.white} />;
  }

  if (active) {
    return (
      <Avatar
        name={getFullName(firstName, lastName)}
        size={size}
        src={avatarUrl != null ? avatarUrl : undefined}
        ignoreFallback
      />
    );
  }

  //Inactive user
  return (
    <Avatar
      size={size}
      icon={<AvatarIcon fill={colors.gray60} boxSize="full" />}
      backgroundColor="unset"
    />
  );
};

export default memo(InternalAdminUserAvatar);
